export const FormData = {
		intro:{
		display: 'Solarize America the new national program which helps homeowners save the maximum amount of money with solar across the country.',
		display2:'',
		options: ['Yes, I do', 'No, I rent'],
		page: 0,
		description: '',
		percentage: 0,
		key:'intro' 
	},
	0:{
		display: 'Texas Educator Energy Savings Program',
		display2:'July 2019',
		description: 'There is a new program in Texas that helps Educators lower their electric bill 50% or more with $0 out of pocket costs. There are additional special incentives available only to Educators and you deserve to know about them!',
		options:['Yes, I want to see if I Qualify'],
		page:0,
		percentage:5,
		key: 'Intrested'
	},
	1: {
		display: 'Do you own your home?' ,
		display2:'',
		options: ['Yes, I do', 'No, I rent'],
		page: 1,
		description: '',
		percentage:25,
		key:'Home Owner'
	},
	2: {
		display: 'What is your highest electric bill in the summer?',
		display2:'',
		options: ['Under $100', '$100 - $200', '$200 - $300', '$300 - $400', '$400+'],
		page: 2,
		description: '',
		percentage:60,
		key:'Summer Electric Bill'
	},
	3: {
		display: "How's your credit score?",
		display2:'',
		options: ['Excellent', 'Above Average', 'Average', 'Needs some repair'],
		page: 3,
		description: '',
		percentage:80,
		key:'Credit Score'
	},
	4 :{
		// display: "YOU QUALIFY FOR SOLAR!",
		// display2:'',
		// options:['Mobile Number ', 'Email ', 'Full Name '],
		// page: 4,
		// description: "To receive your quote we require:",
		// percentage: 95,
		display: "Where should we send your report?",
		display2:'',
		options:['Mobile Number ', 'Email ', 'Full Name '],
		page: 4,
		description: "Our techs are working on the report. Fill out your information so we can send it over to you. One of our account managers may get in contact with you.",
		percentage: 95
	},
	successPage :{
		display: "Thank you for your requesting your free home solar quote!",
		display2:'Our energy auditors will be reaching out ASAP to complete the process.',
		options:[],
		page: 6,
		description: "",
		percentage: 100
	},
	zipcodepage: {
		display: 'SEE IF YOUR ROOF QUALIFIES FOR SOLAR' ,
		display2:'',
		options: ['Zip Code'],
		page: 0,
		description: '',
		percentage:25,
		key:'Home Owner'
	},
	addresspage:{
		display: 'Find Your Roof' ,
		display2:'Enter Your Address',
		options: ['Address'],
		page: 0,
		description: '',
		percentage:25,
		key:'Home Owner'
	},
	renterpage:{
		display: 'Thank you for your interest in going solar!' ,
		display2:"We work with homeowners to improve their cost savings and energy-efficient lifestyles, and are happy assist you if you connect us with the owner of the home. If they end up going solar with us, you'll even earn $250 for the recommendation!",
		options: ['Address'],
		page: 0,
		description: '',
		percentage:25,
		key:'Home Owner'
	},

}